//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CustomizeGif',
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
  },
  data() {
    return {
      img: 'https://static.moele.me/img/channel/image/image-gif-creator-preview-220523@2x.png?auto=format&w=712',
      imgDark: 'https://static.moele.me/img/channel/image/image-gif-creator-preview-dark-220523@2x.png?auto=format&w=712',
    };
  },
};
